import badge from '../images/UnityBadge.png';
import thesis from '../images/thesis.pdf';

export default function Education() {
	return (
		<div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
			<div className="dark-card">
				<p
					style={{
						fontSize: '12px',
						letterSpacing: '0.08em',
						color: 'var(--accent)',
						marginBottom: '8px',
					}}
				>
					10/2020 – 06/2023 · Paola, Malta
				</p>
				<h3 style={{ fontSize: '15px', marginBottom: '4px' }}>
					BSc (Hons) Multimedia Software Development
				</h3>
				<p
					style={{
						fontSize: '13px',
						color: 'var(--text-secondary)',
						marginBottom: '12px',
					}}
				>
					Malta College of Arts, Science & Technology · EQF Level 6
				</p>
				<ul style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
					{[
						'Vue.js for dynamic, interactive user interfaces',
						'Unity & C# for immersive experiences and games',
						'API design in JavaScript, tested with Postman',
						'3D modelling, texturing and animation in Maya',
					].map((b, i) => (
						<li
							key={i}
							style={{
								fontSize: '13px',
								color: '#6b7491',
								display: 'flex',
								gap: '8px',
								lineHeight: 1.5,
							}}
						>
							<span style={{ color: 'var(--accent)', flexShrink: 0 }}>›</span>
							{b}
						</li>
					))}
				</ul>
				<p
					style={{
						fontSize: '12px',
						color: 'var(--text-muted)',
						marginTop: '12px',
					}}
				>
					Thesis:{' '}
					<a href={thesis} target="_blank" rel="noopener noreferrer">
						<em
							style={{
								color: 'var(--text-primary)',
								borderBottom: '1px solid var(--text-muted)',
								cursor: 'pointer',
							}}
						>
							Simulating a Crowd Reacting to an Accident in Virtual Environments
						</em>
					</a>
				</p>
			</div>

			<div className="dark-card">
				<p
					style={{
						fontSize: '12px',
						letterSpacing: '0.08em',
						color: 'var(--accent)',
						marginBottom: '8px',
					}}
				>
					09/2018 – 05/2020 · Paola, Malta
				</p>
				<h3 style={{ fontSize: '15px', marginBottom: '4px' }}>
					Advanced Diploma in IT (Multimedia Software Development)
				</h3>
				<p
					style={{
						fontSize: '13px',
						color: 'var(--text-secondary)',
						marginBottom: '12px',
					}}
				>
					MCAST · EQF Level 4
				</p>
				<ul style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
					{[
						'Multimedia Design',
						'Website Design',
						'Embedded Systems',
						'Networking Concepts',
						'English & Maths',
					].map((s, i) => (
						<li
							key={i}
							style={{
								fontSize: '13px',
								color: '#6b7491',
								display: 'flex',
								gap: '8px',
								lineHeight: 1.5,
							}}
						>
							<span style={{ color: 'var(--accent)', flexShrink: 0 }}>›</span>
							{s}
						</li>
					))}
				</ul>
			</div>

			<div
				className="dark-card"
				style={{ display: 'flex', alignItems: 'center', gap: '16px' }}
			>
				<div style={{ flex: 1, minWidth: 0 }}>
					<p
						style={{
							fontSize: '12px',
							letterSpacing: '0.08em',
							color: 'var(--accent)',
							marginBottom: '8px',
						}}
					>
						10/2024 – 10/2027
					</p>
					<h3 style={{ fontSize: '15px', marginBottom: '6px' }}>
						Unity Certified Associate: Programmer
					</h3>
					<a
						href="https://cp.certmetrics.com/unity/en/public/verify/credential/fcea93683df44903b0bb3b0efdc73a40"
						target="_blank"
						rel="noopener noreferrer"
						style={{
							fontSize: '12px',
							color: 'var(--text-secondary)',
							textDecoration: 'none',
							borderBottom: '1px solid var(--text-muted)',
							paddingBottom: '1px',
						}}
					>
						Verify credential ↗
					</a>
				</div>
				<a
					href="https://cp.certmetrics.com/unity/en/public/verify/credential/fcea93683df44903b0bb3b0efdc73a40"
					target="_blank"
					rel="noopener noreferrer"
					style={{ flexShrink: 0, width: '64px' }}
				>
					<img
						src={badge}
						alt="Unity Certified Associate Badge"
						style={{ width: '64px', height: 'auto' }}
					/>
				</a>
			</div>
		</div>
	);
}
